// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Resources } from '@shared/localizations/Resources';
import { MainWindowManager } from '../UtilsClasses/MainWindowManager';
import TerceraRiskWarningMessageScreenTemplate from '@front/templates/TerceraRiskWarningMessageScreenTemplate.html';
import { TerceraWindowBase } from './TerceraWindowBase';
import { riskWarningMessageScreenHandler } from '@shared/utils/AppHandlers';
import { TerceraButtonStyle } from '@shared/utils/Enums/ButtonEnums';
export class TerceraRiskWarningMessageScreen extends TerceraWindowBase {
    constructor() {
        super();
    }
    getType() {
        return 'TerceraRiskWarningMessageScreen';
    }
    oninit() {
        super.oninit();
        this.on('okClick', this.okClick);
    }
    oncomplete() {
        super.oncomplete();
        this.center();
    }
    okClick() {
        this.close();
    }
    static Show(messageInfo) {
        const scr = new TerceraRiskWarningMessageScreen();
        const userNameLabel = Resources.getResource(messageInfo.Data[0][0]) + ': ';
        const userNameText = messageInfo.Data[0][1];
        const accountNameLabel = Resources.getResource(messageInfo.Data[1][0]) + ': ';
        const accountNameText = messageInfo.Data[1][1];
        const msgText = messageInfo.Data[2][1];
        void scr.set({
            header: Resources.getResource(messageInfo.Name),
            okText: Resources.getResource('general.messageBox.ok'),
            userNameLabel,
            UserName: userNameText,
            accNameLabel: accountNameLabel,
            AccName: accountNameText,
            msgText
        });
        MainWindowManager.AddControl(scr);
        scr.setFocus();
    }
    static RiskWarningMessageScreenHandlerInitialize() {
        riskWarningMessageScreenHandler.Show = TerceraRiskWarningMessageScreen.Show;
    }
}
TerceraWindowBase.extendWith(TerceraRiskWarningMessageScreen, {
    data: function () {
        return {
            movable: false,
            showHeader: true,
            showFooter: false,
            resizable: false,
            showFullscreenCloud: true,
            closeBtnVisible: false,
            width: 400,
            height: 300,
            errorTop: 0,
            header: '',
            okText: '',
            userNameLabel: '',
            UserName: '',
            accNameLabel: '',
            AccName: '',
            msgText: '',
            btnStyle: TerceraButtonStyle.Blue
        };
    },
    partials: { bodyPartial: TerceraRiskWarningMessageScreenTemplate }
});
